export default "__VITE_ASSET__mOh3U0G4__"